import { render, staticRenderFns } from "./ClientAgreementsActive.vue?vue&type=template&id=699c50e8&scoped=true&"
import script from "./ClientAgreementsActive.vue?vue&type=script&lang=js&"
export * from "./ClientAgreementsActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c50e8",
  null
  
)

export default component.exports